// extracted by mini-css-extract-plugin
export default {"month":"CalendarMonth_month__vpJky","header":"CalendarMonth_header__2X9h1","weekdays":"CalendarMonth_weekdays__TL5x2","days":"CalendarMonth_days__dkNuh"};